<template>
  <div class="w-full">
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-card>
          <div slot="header">
            <div class="vx-row flex justify-center items-center m-2">
              <h3 class>Antrian Online Mal Pelayanan Publik Kab. Lombok Tengah</h3>
            </div>
          </div>
          <wrapper :loading="loading" :empty="false">
            <div class="vx-row m-0 w-full">
              <div class="vx-row m-0 w-full justify-center py-5">
                <div class="vx-col w-full md:w-2/3">
                  <vs-input icon-pack="feather" icon="icon-search" placeholder="Cari layanan atau instansi" v-model="filter_search" class="is-label-placeholder w-full" />
                </div>
              </div>
              <div v-if="filter_search == ''" class="vx-col w-full p-5">
                <h3> Seluruh Layanan </h3>
              </div>
              <div v-else class="vx-col w-full p-5">
                <h3> Menampilkan data layanan "{{ filter_search }}"</h3>
              </div>
              <div v-if="isEmpty" class="vx-col w-full p-5 text-center">
                <h5> Mohon maaf, layanan tidak ditemukan.</h5>
              </div>
              <div class="vx-col w-full" v-else>
                <div class="vx-row w-full justify-between">
                  <div class="vx-col w-full md:w-1/2 lg:w-1/3 items-center cursor-pointer" v-for="(item,index) in services" :key="index" @click="selectService(services[index])" >
                    <vs-card class="">
                      <div class="vx-row py-3 mt-3">
                        <div class="vx-col flex items-center">
                          <div class="flext-initial px-5">
                            <img :src="item.logo | agencyLogo" width="64px" alt=""/>
                          </div>
                          <div class="flex-1 pr-5">
                            <div class="text-xl font-bold mb-1">{{item.name}}</div>
                            <div class="text-base">{{item.agency_initial == null ? item.agency_name : item.agency_initial}}</div>
                          </div>
                        </div>
                      </div>
                    </vs-card>
                  </div>
                </div>
              </div>
            </div>
          </wrapper>
        </vs-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col">
        <vs-button
          color="primary"
          class="mb-5"
          icon-pack="feather"
          icon="icon-arrow-left "
          type="border"
          to="/antrian-online/"
        >Kembali</vs-button>
      </div>
    </div>
    <popup-add-queue 
      :active.sync="popupAdd" 
      :services="selectedService" 
    />
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import VueSelect from 'vue-select';
import moment from "moment";
import PopupAddQueue from '@/components/queue/PopupAddQueue.vue';
import Wrapper from '@/components/wrapper/Wrapper.vue';

export default {
  data() {
    return {
      filter_search : "",
      loading : false,
      services : [],
      popularServices : [],
      selectedService : [],
      date: "",
      popupActive : false,
      popupAdd : false,
      lock : '',
      isEmpty : false
    };
  },
  components: {
    Datepicker,
    VueSelect,
    PopupAddQueue,
    Wrapper
  },
  mounted() {
    this.getServiceData();
  },
  methods: {
    getServiceData(){
      clearTimeout(this.lock);
      this.lock = setTimeout(() => {   
        this.$vs.loading();
        this.$http
        .get(`/app/queue-register/services`,{params : {filter_search : this.filter_search}})
        .then(r => {
          this.services = r.data.data.services;
          this.popularServices = r.data.data.popular_services;
          this.services.length == 0 ? this.isEmpty = true : this.isEmpty= false;
        })
        .catch(e => {
          this.parseError(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        }); 
      }, 500);  
    },
    formatterDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    selectService(service){
      this.popupAdd = true
      this.selectedService = service;
    },
  },
  watch: {
    filter_search : function(){       
      this.getServiceData();
    },
  },
  computed: {
    user() {
      return this.$store.state.AppActiveUser;
    }
  }
};
</script>>

<style>
  .vs__dropdown-toggle {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
    font-size: 1rem;
  }
  .vs__selected-options{
    padding: .1rem;
  }
  .vs__search{
    margin-top: 0px;;
  }
</style>